import { yupResolver } from '@hookform/resolvers/yup';
import { enqueueSnackbar } from 'notistack';
import React from 'react';
import { Resolver, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { handleError } from '../../../../shared/functions/handleError';
import { IExpense } from '../../../../shared/interfaces/expenses/IExpense';
import { AdminExpenseService } from '../service';
import { expenseSchema } from './ExpenseCreate';
import ExpenseForm from './ExpenseForm';

const ExpenseUpdate = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id } = useParams();
  const { handleSubmit, control } = useForm<IExpense>({
    resolver: yupResolver(expenseSchema) as unknown as Resolver<IExpense>,
    defaultValues: async () => {
      const response = await AdminExpenseService.getSingle(Number(id));
      return response as IExpense;
    },
  });

  const submitHandler = (formData: IExpense) => {
    id &&
      AdminExpenseService.update(formData, Number(id))
        .then((response) => {
          if (response) {
            navigate(-1);
            enqueueSnackbar(
              t('toasts.successfullyUpdated', { title: formData.name }),
              { variant: 'success' },
            );
          }
        })
        .catch((err) => handleError(err));
  };
  return (
    <form onSubmit={handleSubmit(submitHandler)}>
      <ExpenseForm control={control} isUpdate />
    </form>
  );
};

export default ExpenseUpdate;
